// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lang[data-v-e0f8e170]{display:grid;gap:1.2rem;grid-template-columns:repeat(2,.2fr)}.spacer-2[data-v-e0f8e170]{margin-top:1.5rem}", ""]);
// Exports
module.exports = exports;
